/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";
import { useEffect, useMemo, useRef } from "react";
import queryString from "query-string";
import { makeStyles, withStyles } from "@mui/styles";
import {
  Grid,
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  MenuList,
  Avatar,
  Button
} from "@mui/material";
import Badge from "@mui/material/Badge";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItem from "@mui/material/ListItem";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import logo from "../../images/loanlistheader/group-3.svg";
import dashboardIconFilled from "../../icons/dashboardFilled.svg";
import dashboardIconOutlined from "../../icons/dashboardOutlined.svg";
import logoutIcon from "../../icons/logoutIcon.svg";
import bellIcon from "../../images/notification/notification.svg";
// import rcnCapital from "../../images/loanlistheader/rcn1x.png";
import { LinearProgressBar } from "../sub-headers/LinearProgresBar";
import { RootState } from "../../stores/rootReducer";
import {
  isLATUser,
  isILP,
  isRole,
  isPrivilege,
  isAssetManagement,
  isDrawAMRole,
  isOrigUser,
  isPurchasedLoansViewerOnly
} from "../../utils/AccessManagement";
import { AssetManagementRolesEnum } from "../../utils/constants";
import {
  getNotification
  // notificationClickedUpdate
} from "../../stores/dashboardSection/dashboard.action";
import { Notification } from "../dashboard/notification";
// import { updateSlectedFilters } from "../create-loan.action";
import { getCookie, setCookie } from "../../utils/cookies";
import { HamBurger } from "./hamburger";
import {
  removeSearched
  // deselectActiveBundle,
} from "../../stores/SettlementAndPurchase/SettlementAndPurchase.action";
import { resetAllStores, updateSearchValue } from "../create-loan.action";
import { getConfig } from "../../config/config";
// import { setViewType } from "../../stores/ILP/ILP.action";
import { useStylesHeader } from "./Header.style";
import { ScrollingBanner } from "../../ui-components/ScrollingBanner";
import { notificationClickedUpdate } from "../../stores/dashboardSection/dashboard.reducer";
import { setViewType } from "../../stores/ILP/ILP.reducer";
import { SearchBar } from "./SearchBar";
import { isAnyLATAMRole, isBetweenDesiredRange } from "../../utils/utils";
import { useAppConfig } from "../../stores/AppConfigContext";
import {
  buildHeaderTabs,
  getHeaderMinTabs,
  getUserInitials,
  getPlatformName
} from "./headerTabs";

interface CustomTabProps {
  title: string;
  isSelected: boolean;
  onClick: Function;
  id: number | string;
}

const CustomTab = (props: CustomTabProps) => {
  const classes = useStylesHeader();
  const { title, isSelected, onClick, id } = props;
  return (
    <Grid key={id} className={classes.root}>
      <Grid style={{ display: "flex", justifyContent: "center" }}>
        <Typography
          onClick={() => {
            onClick(id);
          }}
          style={{
            cursor: "pointer",
            color: "##ffffff",
            fontSize: 14,
            textTransform: "uppercase",
            fontWeight: isSelected ? 700 : 400,
            width: "max-content"
          }}
        >
          {title}
        </Typography>
      </Grid>

      <Grid
        style={{
          height: 0,
          borderRadius: 6,
          borderStyle: "solid",
          borderColor: "#ffffff",
          background: "#ffffff",
          margin: "12px 8px 2px 8px",
          borderWidth: 2,
          opacity: isSelected ? 1 : 0,
          padding: "0px 16px"
        }}
      />
    </Grid>
  );
};

interface NotificationIconProps {
  iconClassName: string;
  onClick: (event: React.MouseEvent<HTMLImageElement>) => void;
}

const NotificationIcon = ({ iconClassName, onClick }: NotificationIconProps) => (
  <img
    src={bellIcon}
    className={iconClassName}
    onClick={onClick}
    alt="bell-icon"
  />
);

interface Props {
  value: number;
  setTabValue?: any;
  showTab?: boolean;
  showNotificationIcon?: boolean;
}

export const Header = (props: Props) => {
  const token = getCookie("id_token") || "";
  const { name, email, roles } = JSON.parse(atob(token.split(".")[1]));
  const path = useLocation();
  const navigate = useNavigate();
  const isLAT = isLATUser();
  const isPurchasedLoansViewerRole = isRole(
    AssetManagementRolesEnum.PURCHASED_LOANS_VIEWER
  );
  const isCounsel_Member =
    getCookie("roles")?.includes("COUNSEL_MEMBER") ||
    getCookie("roles")?.includes("COUNSEL_CUSTOM_READ");

  const classes = useStylesHeader();
  const { value, setTabValue, showTab, showNotificationIcon = true } = props;
  const dispatch = useDispatch();
  const tabView = useSelector<RootState, any>((state) => state.spStore.tabView);
  const getLoan = useSelector<RootState, any>(
    (state) => state.createLoanStore.getLoan
  );
  const isPageBlocked = useSelector<RootState, any>(
    (state) => state.createLoanStore.isPageBlocked
  );
  const { unReadCount, notificationClicked } = useSelector<RootState, any>(
    (state) => state.dashboardStore
  );
  const urlParams: any = queryString.parse(
    new URL(window.location.href).search
  );
  const { config } = useAppConfig();

  useEffect(() => {
    // Create a <link> element
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image"; // Specify the type of resource to preload, e.g., 'image', 'script', 'style', etc.
    link.href = logo;

    // Append the <link> element to the <head> of the document
    document.head.appendChild(link);

    // Clean up function to remove the <link> element when the component unmounts
    return () => {
      link.remove();
    };
  }, []); // Empty dependency array ensures the effect runs only once, similar to componentDidMount

  const showGlobalSearch = useMemo(
    () =>
      !(
        window.location.pathname === "/home" ||
        window.location.pathname === "/notification-settings" ||
        window.location.pathname.includes("/counsel") ||
        isAssetManagement() ||
        isOrigUser()
      ),
    []
  );

  const canClick = () => {
    const excludedPaths = ["/home", "/counsel"];
    return !excludedPaths.some((excludedPath) =>
      path.pathname.startsWith(excludedPath)
    );
  };
  const { drawId } = useParams<any>();
  const handleLogoClick = () => {
    // Routes to Dashboard page for originator platform
    // Routes to loans page for ilp platform as there is no dashboard
    // Purchased-loans viewers land on Purchased Loans tab only
    handleChangeHeaderTabs(isPurchasedLoansViewerOnly() ? 14 : 0);
  };
  const handleChangeHeaderTabs = (
    // event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setCookie("view", "Detailed");

    clearFilters();
    dispatch(resetAllStores());
    // Viewer-only: Purchased Loans is tab 14 on Connect home (/loans/list).
    // Do not use the AM branch — tab 14 there is Counsel Data.
    if (isPurchasedLoansViewerOnly()) {
      navigate(`/loans/list?tab=${newValue}`);
      dispatch(setTabValue(newValue));
      return;
    }
    if (!isILP() && !isAssetManagement()) {
      dispatch(notificationClickedUpdate(false));
      if (roles === undefined || roles?.length === 0) {
        navigate(`/loans/list?tab=3`);
        dispatch(setTabValue(3));
        return;
      }
      if (newValue === 2) {
        removeSearched(dispatch);
        // dispatch(deselectActiveBundle());
      }
      navigate(`/loans/list?tab=${newValue}`);
      if (tabView === newValue && !isPageBlocked) window.location.reload();
    } else if (isAssetManagement()) {
      if (newValue === 14) {
        navigate(`/asset/home/counsel/loans?tab=${newValue}`);
      } else {
        navigate(`/asset/home?tab=${newValue}`);
      }
    } else {
      navigate(`/internal/loans/list?tab=${newValue}`);
    }
    dispatch(setTabValue(newValue));
  };
  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleOutsideClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  // useEffect(() => {
  //   document.addEventListener("click", handleClickOutsideHamburger, false);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutsideHamburger, false);
  //   };
  // }, []);
  // const wrapperRefHamburgererRef = useRef<HTMLDivElement>(null);

  // const handleClickOutsideHamburger = (event: any) => {
  //   const node = wrapperRefHamburgererRef.current;
  //   if (wrapperRefHamburgererRef && !node?.contains(event.target)) {
  //     setShowMenu(false);

  //   }
  // };

  useEffect(() => {
    if (!isILP()) {
      dispatch(getNotification(0));
      const interval = setInterval(() => {
        dispatch(getNotification(0));
      }, 300000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const firstName = getCookie("firstName") || "";
  const lastName = getCookie("lastName") || "";

  const isAMRoleDrawDetails = () => isDrawAMRole() && drawId;

  const MIN_TABS = getHeaderMinTabs(!!isAMRoleDrawDetails());
  const initials = getUserInitials(firstName, lastName);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElNot, setAnchorElNot] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const tabs = buildHeaderTabs({
    roles,
    showTab,
    isAMRoleDrawDetails: !!isAMRoleDrawDetails(),
    onDefaultTab: (tabId) => dispatch(setTabValue(tabId))
  });
  const handleMenuNot = (event: any) => {
    if (!isILP()) {
      dispatch(notificationClickedUpdate(false));
      setAnchorElNot(true);
    }
  };
  const wrapperRef = useRef<HTMLDivElement>(null);
  const handleOutsideClick = (e: any) => {
    const node = wrapperRef.current;
    if (wrapperRef && !node?.contains(e.srcElement)) {
      setAnchorElNot(false);
      // setShowMenu(false);
    }
  };
  useEffect(() => {
    if (!isILP()) {
      if (notificationClicked) {
        setAnchorElNot(false);
      }
    }
  }, [notificationClicked]);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const logOutClick = () => {
    setAnchorEl(null);
    localStorage.removeItem("customizedColumn");
    sessionStorage.removeItem("excelUpload");
    navigate("/logout");
  };
  const clickStatus = {
    toorakConnect: false,
    internalProcessing: false,
    boxConditionMonitoring: false,
    assetManagement: false
  };
  if (path.pathname.startsWith("/internal")) {
    clickStatus.internalProcessing = true;
  } else if (path.pathname.startsWith("/loan")) {
    clickStatus.toorakConnect = true;
  } else if (
    path.pathname.startsWith("/asset") ||
    path.pathname.startsWith("/drawDetails") ||
    path.pathname.startsWith("/serviceronboarding") ||
    path.pathname.startsWith("/purchasedLoanDetails")
  ) {
    clickStatus.assetManagement = true;
  }

  let checkHome = false;
  if (path.pathname.startsWith("/home")) {
    checkHome = true;
  }

  const clearSearchValue = () => {
    setCookie("globalSearchValue", "");
    setCookie("filterCleared", "true");
    dispatch(updateSearchValue(""));
  };

  const toorakConnectClick = () => {
    setAnchorEl(null);
    dispatch(setViewType("details"));
    navigate("/loans/list?tab=1");
    clearSearchValue();
  };
  const internalloanProcessingClick = () => {
    setAnchorEl(null);
    // if (
    //   !isRole(InternalRolesEnum.LAT_ADMIN) &&
    //   (isRole(InternalRolesEnum.LAT_APPROVER) ||
    //     isRole(InternalRolesEnum.LAT_INQUIRY))
    // ) {
    //   dispatch(push("/internal/loans/list?tab=2"));
    // } else {
    navigate(`/internal/loans/list?tab=0`);
    //  }
    clearSearchValue();
  };

  const onBoxConditionMonitoring = () => {
    const configParams = getConfig();
    const refreshTokenId = getCookie("refresh_token");
    window.location.href = `${configParams.boxRedirectUrl}/callBack?token=${refreshTokenId}`;
    clearSearchValue();
  };

  const assetManagementClick = () => {
    setAnchorEl(null);
    navigate(`/asset/home`);
    clearSearchValue();
  };

  const clearFilters = () => {
    // dispatch(updateSlectedFilters({}));
    clearSearchValue();
    // dispatch({
    //   type: DROPDOWN_DATA_SUCCESS,
    //   payload: {
    //     loanLists: {},
    //     pageCount: 0
    //   }
    // });
  };
  const StyledMenu: any = withStyles({
    paper: {
      border: "1px solid #d3d4d5"
    }
  })(
    (props: {
      open?: any;
      anchorEl?: any;
      id?: any;
      onClose?: any;
      keepMounted?: any;
    }) => (
      <Menu
        elevation={0}
        // getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        open={props.open}
        id={props.id}
        onClose={props.onClose}
        keepMounted={props.keepMounted}
        {...props}
      />
    )
  );

  // const StyledMenuItem = withStyles((theme) => ({
  //   root: {
  //     '&:focus': {
  //       backgroundColor: theme.palette.primary.main,
  //       '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
  //         color: theme.palette.common.white,
  //       },
  //     },
  //   }
  // }))(MenuItem);
  const useMenuStyles = makeStyles((theme) => ({
    userDetailList: {
      border: "0",
      borderBottom: "1px solid #e2e4f1",
      backgroundColor: "transparent"
    },
    logoutContainer: {
      padding: "6px 0 0 0",
      listStyle: "none",
      textAlign: "left",
      marginBottom: "0px"
    },
    mainMenuItem: {
      cursor: "pointer",
      padding: "12px 0 12px 0"
    },
    dividerStyle: {
      paddingTop: "10px",
      paddingBottom: "12px"
    },
    signOutStyle: {
      paddingTop: "10px",
      fontSize: "12px"
    }
  }));
  const classesStyle = useMenuStyles();
  // const handleClickBulkUpload = () => {
  //   dispatch(updateBulkUpload(true));
  // }

  // More Menu
  const [moreOpen, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const moreOptionClose: any = (event: React.MouseEvent<EventTarget>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(moreOpen);
  React.useEffect(() => {
    if (prevOpen.current === true && moreOpen === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = moreOpen;
  }, [moreOpen]);
  // More Menu

  const iconButton = () => (
    <IconButton
      aria-label="account of current user"
      aria-controls="menu-appbar"
      aria-haspopup="true"
      onClick={handleMenu}
      color="inherit"
      style={{ padding: "12px 12px" }}
    >
      <div id="profileImage" className={classes.profileImage}>
        {initials.toUpperCase()}
      </div>
    </IconButton>
  );
  const switchToOriginator = () => (
    <Grid item xs={3} className={classes.imgUser2}>
      <Box display={{ xs: "none", sm: "none", md: "none", lg: "block" }}>
        {iconButton()}
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <ListItem className={classesStyle.userDetailList}>
            <ListItemAvatar>
              <Avatar>
                <div id="profileImage" className={classes.profileImage}>
                  {initials.toUpperCase()}
                </div>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} secondary={email} />
          </ListItem>
          <MenuList className={classesStyle.logoutContainer}>
            <MenuItem
              onClick={logOutClick}
              className={classesStyle.signOutStyle}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <img src={logoutIcon} alt="logout-icon" />
              </ListItemIcon>
              <Typography variant="inherit" noWrap>
                Signout
              </Typography>
            </MenuItem>
          </MenuList>
        </StyledMenu>
      </Box>
      <HamBurger showTab={showTab} />
    </Grid>
  );
  const switchToCounsel = () => (
    <Grid item xs={3} className={classes.imgUser2}>
      <Box display={{ xs: "none", sm: "none", md: "none", lg: "block" }}>
        {iconButton()}
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <ListItem className={classesStyle.userDetailList}>
            <ListItemAvatar>
              <Avatar>
                <div id="profileImage" className={classes.profileImage}>
                  {initials.toUpperCase()}
                </div>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} secondary={email} />
          </ListItem>
          <MenuList className={classesStyle.logoutContainer}>
            <MenuItem
              onClick={logOutClick}
              className={classesStyle.signOutStyle}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <img src={logoutIcon} alt="logout-icon" />
              </ListItemIcon>
              <Typography variant="inherit" noWrap>
                Signout
              </Typography>
            </MenuItem>
          </MenuList>
        </StyledMenu>
      </Box>
      <HamBurger showTab={showTab} />
    </Grid>
  );

  const platFormName = getPlatformName(clickStatus);

  const switchToPlatform = () => (
    <Grid item xs={5}>
      <Box
        display={{ xs: "none", sm: "none", md: "none", lg: "flex" }}
        className={
          clickStatus.toorakConnect
            ? classes.imgUserToorakConnect
            : classes.imgUser
        }
      >
        <Grid className={classes.textContainer} item xs={10}>
          <p
            className={
              clickStatus.toorakConnect
                ? `${classes.statusText} ${classes.statusTextPadding2}`
                : `${classes.statusText} ${classes.statusTextPadding1}`
            }
          >
            {platFormName}
          </p>
        </Grid>
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
          className={classes.IconText}
        >
          <div id="profileImage" className={classes.profileImage}>
            {initials.toUpperCase()}
          </div>
        </IconButton>
        <ArrowLeftIcon
          fontSize="large"
          htmlColor="white"
          onClick={(e: any) => handleMenu(e)}
          style={{
            width: 14,
            height: 16,
            marginTop: 14,
            transform: open ? "rotate(90deg)" : "rotate(270deg)",
            objectFit: "contain",
            cursor: "pointer"
          }}
          component="svg"
        />
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <ListItem className={classesStyle.userDetailList}>
            <ListItemAvatar>
              <Avatar>
                <div id="profileImage" className={classes.profileImage}>
                  {initials.toUpperCase()}
                </div>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} secondary={email} />
          </ListItem>
          <MenuList className={classesStyle.logoutContainer}>
            {isLAT && (
              <>
                {!isPurchasedLoansViewerRole && (
                  <MenuItem onClick={toorakConnectClick}>
                    <ListItemIcon className={classes.listItemIcon}>
                      {clickStatus.toorakConnect ? (
                        <img src={dashboardIconFilled} alt="dashboard-icon" />
                      ) : (
                        <img
                          src={dashboardIconOutlined}
                          alt="dashboard-icon-filled"
                        />
                      )}
                    </ListItemIcon>
                    <Typography
                      variant="inherit"
                      className={
                        !clickStatus.toorakConnect
                          ? classes.colorNormal
                          : classes.colorBlue
                      }
                      noWrap
                    >
                      Toorak Connect
                    </Typography>
                  </MenuItem>
                )}
                {isPrivilege("view_workflow") && (
                  <MenuItem
                    onClick={internalloanProcessingClick}
                    divider
                    className={classesStyle.dividerStyle}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      {clickStatus.internalProcessing ? (
                        <img src={dashboardIconFilled} alt="dashboard-icon" />
                      ) : (
                        <img
                          src={dashboardIconOutlined}
                          alt="dashboard-icon-filled"
                        />
                      )}
                    </ListItemIcon>
                    <Typography
                      variant="inherit"
                      className={
                        !clickStatus.internalProcessing
                          ? classes.colorNormal
                          : classes.colorBlue
                      }
                      noWrap
                    >
                      Internal Loan Processing
                    </Typography>
                  </MenuItem>
                )}
                {!isPurchasedLoansViewerRole && (
                  <MenuItem
                    onClick={onBoxConditionMonitoring}
                    divider
                    className={classesStyle.dividerStyle}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      {clickStatus.boxConditionMonitoring ? (
                        <img src={dashboardIconFilled} alt="dashboard-icon" />
                      ) : (
                        <img
                          src={dashboardIconOutlined}
                          alt="dashboard-icon-filled"
                        />
                      )}
                    </ListItemIcon>
                    <Typography
                      variant="inherit"
                      className={
                        !clickStatus.boxConditionMonitoring
                          ? classes.colorNormal
                          : classes.colorBlue
                      }
                      noWrap
                    >
                      Box Condition Monitoring
                    </Typography>
                  </MenuItem>
                )}
                {isAnyLATAMRole() && (
                  <MenuItem onClick={assetManagementClick}>
                    <ListItemIcon className={classes.listItemIcon}>
                      {clickStatus.assetManagement ? (
                        <img src={dashboardIconFilled} alt="dashboard-icon" />
                      ) : (
                        <img
                          src={dashboardIconOutlined}
                          alt="dashboard-icon-filled"
                        />
                      )}
                    </ListItemIcon>
                    <Typography
                      variant="inherit"
                      className={
                        !clickStatus.assetManagement
                          ? classes.colorNormal
                          : classes.colorBlue
                      }
                      noWrap
                    >
                      Asset Management
                    </Typography>
                  </MenuItem>
                )}
              </>
            )}
            <MenuItem
              onClick={logOutClick}
              className={classesStyle.signOutStyle}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <img src={logoutIcon} alt="logout-icon" />
              </ListItemIcon>
              <Typography variant="inherit" noWrap>
                Signout
              </Typography>
            </MenuItem>
          </MenuList>
        </StyledMenu>
      </Box>
      <HamBurger showTab={showTab} />
    </Grid>
  );
  const switchToHome = () => (
    <Grid item xs={3} className={classes.imgUser2}>
      <Box display={{ xs: "none", sm: "none", md: "none", lg: "block" }}>
        {iconButton()}
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <ListItem className={classesStyle.userDetailList}>
            <ListItemAvatar>
              <Avatar>
                <div id="profileImage" className={classes.profileImage}>
                  {initials.toUpperCase()}
                </div>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} secondary={email} />
          </ListItem>
          <MenuList className={classesStyle.logoutContainer}>
            {!isPurchasedLoansViewerRole && (
              <MenuItem onClick={toorakConnectClick}>
                <ListItemIcon className={classes.listItemIcon}>
                  {clickStatus.toorakConnect ? (
                    <img src={dashboardIconFilled} alt="dashboard-icon" />
                  ) : (
                    <img
                      src={dashboardIconOutlined}
                      alt="dashboard-icon-filled"
                    />
                  )}
                </ListItemIcon>
                <Typography
                  variant="inherit"
                  className={
                    !clickStatus.toorakConnect
                      ? classes.colorNormal
                      : classes.colorBlue
                  }
                  noWrap
                >
                  Toorak Connect
                </Typography>
              </MenuItem>
            )}
            {isPrivilege("view_workflow") && (
              <MenuItem
                onClick={internalloanProcessingClick}
                divider
                className={classesStyle.dividerStyle}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  {clickStatus.internalProcessing ? (
                    <img src={dashboardIconFilled} alt="dashboard-icon" />
                  ) : (
                    <img
                      src={dashboardIconOutlined}
                      alt="dashboard-icon-filled"
                    />
                  )}
                </ListItemIcon>
                <Typography
                  variant="inherit"
                  className={
                    !clickStatus.internalProcessing
                      ? classes.colorNormal
                      : classes.colorBlue
                  }
                  noWrap
                >
                  Internal Loan Processing
                </Typography>
              </MenuItem>
            )}
            {isAnyLATAMRole() && (
              <MenuItem onClick={assetManagementClick}>
                <ListItemIcon className={classes.listItemIcon}>
                  {clickStatus.assetManagement ? (
                    <img src={dashboardIconFilled} alt="dashboard-icon" />
                  ) : (
                    <img
                      src={dashboardIconOutlined}
                      alt="dashboard-icon-filled"
                    />
                  )}
                </ListItemIcon>
                <Typography
                  variant="inherit"
                  className={
                    !clickStatus.assetManagement
                      ? classes.colorNormal
                      : classes.colorBlue
                  }
                  noWrap
                >
                  Asset Management
                </Typography>
              </MenuItem>
            )}
            <MenuItem
              onClick={logOutClick}
              className={classesStyle.signOutStyle}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <img src={logoutIcon} alt="logout-icon" />
              </ListItemIcon>
              <Typography variant="inherit" noWrap>
                Signout
              </Typography>
            </MenuItem>
          </MenuList>
        </StyledMenu>
      </Box>
      <HamBurger showTab={showTab} />
    </Grid>
  );

  const platformDecider = () => {
    if (isCounsel_Member) {
      return switchToCounsel();
    }
    if (!isLAT) {
      return switchToOriginator();
    }
    if (!checkHome) {
      return switchToPlatform();
    }
    return switchToHome();
  };

  const { selectedTab, shouldTheExtraTabBeShown } = useMemo(
    () => ({
      selectedTab: tabs.find((tabData) => tabData.id === value),
      shouldTheExtraTabBeShown:
        tabs.length > MIN_TABS &&
        value >= MIN_TABS &&
        !tabs.slice(0, MIN_TABS).find((tabData) => tabData.id === value)
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, tabs]
  );

  const organizationName = useMemo(
    () => getCookie("organizationName") || "",
    []
  );

  return (
    // <AppBar position="static" color="default" className={classes.paperHeader}>
    <div style={{ position: "fixed", width: "100%", zIndex: 1100 }}>
      {isBetweenDesiredRange(
        config?.bannerConfig?.startDate,
        config?.bannerConfig?.endDate
      ) && <ScrollingBanner text={config?.bannerConfig?.message} />}
      <AppBar
        position="static"
        className={classes.paperHeader}
        data-testid="app-header"
      >
        <Grid
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          <Grid item className={classes.wrapper}>
            <Grid
              item
              className={classes.logo}
              style={
                canClick()
                  ? { display: "flex", cursor: "pointer" }
                  : { display: "flex" }
              }
              onClick={canClick() ? handleLogoClick : undefined}
            >
              <img src={logo} alt="toorak_logo" className={classes.imgLogo} />
            </Grid>
            <Grid
              item
              component={Box}
              display={{ xs: "none", sm: "none", md: "none", lg: "flex" }}
              style={{ alignItems: "flex-end", marginBottom: "3px" }}
            >
              {tabs.map((item, index) => {
                if (item.hide || !item.title) return null;
                return (
                  <React.Fragment key={item.id}>
                    {index < MIN_TABS && (
                      <CustomTab
                        title={item.title}
                        id={item.id}
                        isSelected={item.id === Number(urlParams.tab)}
                        onClick={handleChangeHeaderTabs}
                      />
                    )}
                  </React.Fragment>
                );
              })}
              {shouldTheExtraTabBeShown && selectedTab?.title && (
                <CustomTab
                  title={selectedTab?.title}
                  id={selectedTab?.id}
                  isSelected={selectedTab?.id === Number(urlParams.tab)}
                  onClick={handleChangeHeaderTabs}
                />
              )}
              {tabs.length > MIN_TABS && (
                <div className={classes.moreMenuContainer}>
                  <Button
                    ref={anchorRef}
                    aria-controls={moreOpen ? "menu-list-grow" : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    className={`${classes.moreButton} more-button`}
                  >
                    <span style={{ marginRight: 8 }}>More </span>
                    <span className="arrow-icon" />
                  </Button>

                  <Popper
                    className={`${classes.dropdownListContainer} dropdown-list-container`}
                    open={moreOpen}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom"
                              ? "center top"
                              : "center bottom"
                        }}
                      >
                        <Paper style={{ width: "160px" }}>
                          <ClickAwayListener onClickAway={moreOptionClose}>
                            <MenuList
                              autoFocusItem={moreOpen}
                              id="menu-list-grow"
                              onKeyDown={handleListKeyDown}
                            >
                              {tabs.map((item, index) => {
                                if (item.hide) return null;

                                return index >= MIN_TABS ? (
                                  <MenuItem
                                    onClick={() => {
                                      handleChangeHeaderTabs(item.id);
                                      setOpen((prevOpen) => !prevOpen);
                                    }}
                                    key={item.id}
                                  >
                                    {item.title}
                                  </MenuItem>
                                ) : null;
                              })}
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid item className={classes.userInfo}>
            <div
              style={{
                minWidth: shouldTheExtraTabBeShown ? "18vw" : "19vw",
                margin: "auto"
              }}
            >
              {" "}
              {showGlobalSearch && <SearchBar />}
            </div>

            {!isLAT && (
              <Grid item className={classes.imgCapitalContainer}>
                {/* <img
                  src={rcnCapital}
                   alt="org_logo"
                   className={classes.imgCapital}
                 /> */}
                <span style={{ color: "#ffffff" }}>{organizationName}</span>
              </Grid>
            )}
            {showNotificationIcon && (
              <Grid item className={classes.notifyIconContainer}>
                {roles?.length > 0 && (
                  <Badge
                    badgeContent={unReadCount}
                    data-testid="notification-badge-icon"
                    overlap="circular"
                    variant="standard"
                    // onClick={handleMenuNot}
                    className="notificationNumber"
                  >
                    <NotificationIcon
                      iconClassName={classes.icon}
                      onClick={handleMenuNot}
                    />
                    {anchorElNot && (
                      <div className={classes.customWidth} ref={wrapperRef}>
                        <Notification fromBell />
                      </div>
                    )}
                  </Badge>
                )}
              </Grid>
            )}
            {platformDecider()}
          </Grid>
        </Grid>
      </AppBar>
      {getLoan.loadingPostSubmit ? <LinearProgressBar /> : null}
    </div>
  );
};